<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="Markvision Enterprise">
     Markvision Enterprise
    </a>
   </p>
   <p class="toc-1-style">
    <a href="change-history.html#change-history" title="Change history">
     Change history
    </a>
   </p>
   <div id="divd0e10">
   </div>
   <p class="toc-1-style">
    <a href="overview-chapter.html#overview-chapter" title="Overview">
     Overview
    </a>
   </p>
   <div id="divd0e228">
    <p class="toc-2-style">
     <a href="overview-chapter.html#overview-markvision-enterprise" title="Understanding Markvision Enterprise">
      Understanding Markvision Enterprise
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="getting-started-chapter.html#getting-started-chapter" title="Getting started">
     Getting started
    </a>
   </p>
   <div id="divd0e257">
    <p class="toc-2-style">
     <a href="best-practices-topic.html#best-practices" title="Best practices">
      Best practices
     </a>
    </p>
    <p class="toc-2-style">
     <a href="system-requirements-topic.html#system-requirements" title="System requirements">
      System requirements
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-languages-topic.html#supported-languages" title="Supported languages">
      Supported languages
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-printer-models-topic.html#supported-printer-models" title="Supported printer models">
      Supported printer models
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-database-topic.html#setting-up-database" title="Setting up the database">
      Setting up the database
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-mve-run-as-user-topic.html#d0e1059" title="Setting up a run-as user">
      Setting up a run-as user
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-markvision-topic.html#installing-markvision" title="Installing MVE">
      Installing MVE
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-mve-silently-topic.html#installing-mve-silently" title="Installing MVE silently">
      Installing MVE silently
     </a>
    </p>
    <p class="toc-2-style">
     <a href="accessing-mve-topic.html#accessing-mve" title="Accessing MVE">
      Accessing MVE
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-language-topic.html#changing-language" title="Changing the language">
      Changing the language
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-your-password-topic.html#changing-your-password" title="Changing your password">
      Changing your password
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintaining-application-chapter.html#maintaining-application-chapter" title="Maintaining the application">
     Maintaining the application
    </a>
   </p>
   <div id="divd0e1642">
    <p class="toc-2-style">
     <a href="upgrading-to-latest-version-topic.html#upgrading-to-latest-version" title="Upgrading to MVE 4.1.2">
      Upgrading to MVE 4.1.2
     </a>
    </p>
    <p class="toc-2-style">
     <a href="backing-up-and-restoring-database-topic.html#backing-up-and-restoring-database" title="Backing up and restoring the database">
      Backing up and restoring the database
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-installer-settings-topic.html#changing-installer-settings" title="Updating the installer settings after installation">
      Updating the installer settings after installation
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-user-access-chapter.html#setting-user-access-chapter" title="Setting up user access">
     Setting up user access
    </a>
   </p>
   <div id="divd0e1917">
    <p class="toc-2-style">
     <a href="setting-up-user-access-overview-topic.html#setting-up-user-access-overview" title="Overview">
      Overview
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-user-roles-topic.html#understanding-user-roles" title="Understanding user roles">
      Understanding user roles
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-users-topic.html#managing-users" title="Managing users">
      Managing users
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-ldap-server-authentication-topic.html#enabling-ldap-server-authentication" title="Enabling LDAP server authentication">
      Enabling LDAP server authentication
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-ldap-server-certificates-topic.html#installing-ldap-server-certificates" title="Installing LDAP server certificates">
      Installing LDAP server certificates
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="discovering-devices-chapter.html#discovering-devices-chapter" title="Discovering printers">
     Discovering printers
    </a>
   </p>
   <div id="divd0e2298">
    <p class="toc-2-style">
     <a href="creating-discovery-profile-topic.html#creating-discovery-profile" title="Creating a discovery profile">
      Creating a discovery profile
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-discovery-profiles-topic.html#managing-discovery-profiles" title="Managing discovery profiles">
      Managing discovery profiles
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sample-scenario-discovering-printers-topic.html#sample-scenario-discovering-printers" title="Sample scenario: Discovering printers">
      Sample scenario: Discovering printers
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="finding-devices-chapter.html#finding-devices-chapter" title="Viewing printers">
     Viewing printers
    </a>
   </p>
   <div id="divd0e2546">
    <p class="toc-2-style">
     <a href="viewing-printer-list-topic.html#viewing-printer-list" title="Viewing the printer list">
      Viewing the printer list
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-device-information-topic.html#viewing-device-information" title="Viewing the printer information">
      Viewing the printer information
     </a>
    </p>
    <p class="toc-2-style">
     <a href="exporting-data-topic.html#exporting-data" title="Exporting printer data">
      Exporting printer data
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-views-topic.html#managing-views" title="Managing views">
      Managing views
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-printer-listing-view-topic.html#changing-printer-listing-view" title="Changing the printer listing view">
      Changing the printer listing view
     </a>
    </p>
    <p class="toc-2-style">
     <a href="filtering-printers-using-search-bar-topic.html#filtering-printers-using-search-bar" title="Filtering printers using the search bar">
      Filtering printers using the search bar
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-keywords-topic.html#managing-keywords" title="Managing keywords">
      Managing keywords
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-device-life-cycle-states-topic.html#d0e3006" title="Using saved searches">
      Using saved searches
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sample-scenario-monitor-fleet-topic.html#sample-scenario-monitor-fleet" title="Sample scenario: Monitoring the toner levels of your fleet">
      Sample scenario: Monitoring the toner levels of your fleet
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-devices-chapter.html#securing-devices-chapter" title="Securing printer communications">
     Securing printer communications
    </a>
   </p>
   <div id="divd0e3943">
    <p class="toc-2-style">
     <a href="understanding-security-status-topic.html#understanding-security-status" title="Understanding printer security states">
      Understanding printer security
states
     </a>
    </p>
    <p class="toc-2-style">
     <a href="securing-printers-using-default-config-topic.html#securing-printers-using-default-config" title="Securing printers using the default configurations">
      Securing printers
using the default configurations
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-fac-permissions-topic.html#understanding-fac-permissions" title="Understanding permissions and function access controls">
      Understanding permissions and function access controls
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-device-security-topic.html#configuring-device-security" title="Configuring printer security">
      Configuring printer security
     </a>
    </p>
    <p class="toc-2-style">
     <a href="securing-printer-communications-on-your-fleet-topic.html#securing-printer-communications-on-your-fleet" title="Securing printer communications on your fleet">
      Securing
printer communications on your fleet
     </a>
    </p>
    <p class="toc-2-style">
     <a href="securing-printers-topic.html#securing-printers" title="Other ways to secure your printers">
      Other ways to secure your printers
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="managing-assets-chapter.html#managing-assets-chapter" title="Managing printers">
     Managing printers
    </a>
   </p>
   <div id="divd0e4307">
    <p class="toc-2-style">
     <a href="restarting-printer-topic.html#restarting-printer" title="Restarting the printer">
      Restarting the printer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-ews-topic.html#viewing-ews" title="Viewing the printer Embedded Web Server">
      Viewing the printer Embedded Web Server
     </a>
    </p>
    <p class="toc-2-style">
     <a href="auditing-devices-topic.html#auditing-devices" title="Auditing printers">
      Auditing printers
     </a>
    </p>
    <p class="toc-2-style">
     <a href="updating-printer-status-topic.html#updating-printer-status" title="Updating printer status">
      Updating printer status
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-device-state-topic.html#setting-device-state" title="Setting the printer state">
      Setting the printer state
     </a>
    </p>
    <p class="toc-2-style">
     <a href="assigning-configurations-to-devices-topic.html#assigning-configurations-to-devices" title="Assigning configurations to printers">
      Assigning configurations to printers
     </a>
    </p>
    <p class="toc-2-style">
     <a href="unassigning-configurations-topic.html#unassigning-configurations" title="Unassigning configurations">
      Unassigning configurations
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enforcing-configurations-topic.html#enforcing-configurations" title="Enforcing configurations">
      Enforcing configurations
     </a>
    </p>
    <p class="toc-2-style">
     <a href="checking-device-conformance-topic.html#checking-device-conformance" title="Checking the printer conformance with a configuration">
      Checking the printer conformance with a configuration
     </a>
    </p>
    <p class="toc-2-style">
     <a href="deploying-files-to-printers-topic.html#deploying-files-to-printers" title="Deploying files to printers">
      Deploying files to printers
     </a>
    </p>
    <p class="toc-2-style">
     <a href="updating-printer-firmware-topic.html#updating-printer-firmware" title="Updating the printer firmware">
      Updating the printer firmware
     </a>
    </p>
    <p class="toc-2-style">
     <a href="uninstalling-applications-from-devices-topic.html#uninstalling-applications-from-devices" title="Uninstalling applications from printers">
      Uninstalling applications from printers
     </a>
    </p>
    <p class="toc-2-style">
     <a href="assigning-events-to-device-topic.html#assigning-events-to-device" title="Assigning events to printers">
      Assigning events to printers
     </a>
    </p>
    <p class="toc-2-style">
     <a href="assigning-keyword-topic.html#assigning-keyword" title="Assigning keywords to printers">
      Assigning keywords to printers
     </a>
    </p>
    <p class="toc-2-style">
     <a href="entering-credentials-secured-printers-topic.html#entering-credentials-secured-printers" title="Entering credentials to secured printers">
      Entering credentials to secured printers
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-printer-certificates-manually-topic.html#configuring-printer-certificates-manually" title="Configuring default printer certificates manually">
      Configuring default printer certificates manually
     </a>
    </p>
    <p class="toc-2-style">
     <a href="removing-printers-topic.html#removing-printers" title="Removing printers">
      Removing printers
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="managing-configurations-chapter.html#managing-configurations-chapter" title="Managing configurations">
     Managing configurations
    </a>
   </p>
   <div id="divd0e4913">
    <p class="toc-2-style">
     <a href="managing-configurations-overview-topic.html#managing-configurations-overview" title="Overview">
      Overview
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-configuration-topic.html#creating-configuration" title="Creating a configuration">
      Creating a configuration
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-configuration-from-printer-topic.html#creating-configuration-from-printer" title="Creating a configuration from a printer">
      Creating a configuration from a printer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sample-scenario-cloning-configurations-topic.html#sample-scenario-cloning-configurations" title="Sample scenario: Cloning a configuration">
      Sample scenario: Cloning a configuration
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-advanced-security-component-topic.html#creating-advanced-security-component" title="Creating an advanced security component from a printer">
      Creating an advanced security component from a printer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="generating-printable-version-topic.html#generating-printable-version" title="Generating a printable version of the configuration settings">
      Generating a printable version
of the configuration settings
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-variable-settings-topic.html#understanding-variable-settings" title="Understanding variable settings">
      Understanding variable settings
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-color-permissions-topic.html#configuring-color-permissions" title="Configuring the color print permissions">
      Configuring the color print permissions
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-applications-package-topic.html#creating-applications-package" title="Creating an applications package">
      Creating an applications package
     </a>
    </p>
    <p class="toc-2-style">
     <a href="importing-exporting-configuration-file-topic.html#importing-exporting-configuration-file" title="Importing or exporting a configuration">
      Importing or exporting a configuration
     </a>
    </p>
    <p class="toc-2-style">
     <a href="importing-files-to-resource-library-topic.html#importing-files-to-resource-library" title="Importing files to the resource library">
      Importing files to the resource library
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-cert-auto-manage-chapter.html#setting-up-cert-auto-manage-chapter" title="Managing certificates">
     Managing certificates
    </a>
   </p>
   <div id="divd0e5409">
    <p class="toc-2-style">
     <a href="setting-up-MVE-manage-certificates-automatically-group.html#d0e5412" title="Setting up MVE to manage certificates automatically">
      Setting up MVE to manage certificates automatically
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-certificates-using-SCEP-group.html#d0e5629" title="Managing certificates using Microsoft Certificate Authority through SCEP">
      Managing certificates using Microsoft Certificate Authority through SCEP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-certificates-using-MSCEWS-group.html#d0e6351" title="Managing certificates using Microsoft Certificate Authority through MSCEWS">
      Managing certificates using Microsoft Certificate Authority through MSCEWS
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-certificates-using-OpenXPKI-CA-group.html#d0e7361" title="Managing certificates using OpenXPKI Certificate Authority">
      Managing certificates using OpenXPKI Certificate Authority
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="managing-device-alerts-chapter.html#managing-device-alerts-chapter" title="Managing printer alerts">
     Managing printer alerts
    </a>
   </p>
   <div id="divd0e8427">
    <p class="toc-2-style">
     <a href="managing-printer-alerts-overview-topic.html#managing-printer-alerts-overview" title="Overview">
      Overview
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-action-topic.html#creating-action" title="Creating an action">
      Creating an action
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-action-placeholders-topic.html#understanding-action-placeholders" title="Understanding action placeholders">
      Understanding action placeholders
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-actions-topic.html#managing-actions" title="Managing actions">
      Managing actions
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-event-topic.html#creating-event" title="Creating an event">
      Creating an event
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-printer-alerts-topic.html#understanding-printer-alerts" title="Understanding printer alerts">
      Understanding printer alerts
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-events-topic.html#managing-events" title="Managing events">
      Managing events
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="viewing-tasks-chapter.html#viewing-tasks-chapter" title="Viewing task status and history">
     Viewing task status and history
    </a>
   </p>
   <div id="divd0e9059">
    <p class="toc-2-style">
     <a href="viewing-task-status-history-overview-topic.html#viewing-task-status-history-overview" title="Overview">
      Overview
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-task-status-topic.html#viewing-task-status" title="Viewing the task status">
      Viewing the task status
     </a>
    </p>
    <p class="toc-2-style">
     <a href="stopping-tasks-topic.html#stopping-tasks" title="Stopping tasks">
      Stopping tasks
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-logs-topic.html#viewing-logs" title="Viewing logs">
      Viewing logs
     </a>
    </p>
    <p class="toc-2-style">
     <a href="clearing-logs-topic.html#clearing-logs" title="Clearing logs">
      Clearing logs
     </a>
    </p>
    <p class="toc-2-style">
     <a href="exporting-logs-topic.html#exporting-logs" title="Exporting logs">
      Exporting logs
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="scheduling-tasks.html#scheduling-tasks" title="Scheduling tasks">
     Scheduling tasks
    </a>
   </p>
   <div id="divd0e9167">
    <p class="toc-2-style">
     <a href="creating-schedule-topic.html#creating-schedule" title="Creating a schedule">
      Creating a schedule
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-schedules-topic.html#managing-schedules" title="Managing scheduled tasks">
      Managing scheduled tasks
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="admin-tasks-chapter.html#admin-tasks-chapter" title="Performing other administrative tasks">
     Performing other administrative tasks
    </a>
   </p>
   <div id="divd0e9309">
    <p class="toc-2-style">
     <a href="configuring-system-settings-topic.html#configuring-system-settings" title="Configuring general settings">
      Configuring general settings
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-email-settings-topic.html#configuring-email-settings" title="Configuring e-mail settings">
      Configuring e-mail settings
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adding-login-disclaimer-topic.html#adding-login-disclaimer" title="Adding a login disclaimer">
      Adding a login disclaimer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="signing-mve-certificate-topic.html#signing-mve-certificate" title="Signing the MVE certificate">
      Signing the MVE certificate
     </a>
    </p>
    <p class="toc-2-style">
     <a href="removing-user-information-topic.html#removing-user-information" title="Removing user information and references">
      Removing user information and references
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="faq-chapter.html#faq-chapter" title="Frequently asked questions">
     Frequently asked questions
    </a>
   </p>
   <div id="divd0e9549">
    <p class="toc-2-style">
     <a href="faq-chapter.html#frequently-asked-questions" title="Markvision Enterprise FAQ">
      Markvision Enterprise FAQ
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter" title="Troubleshooting">
     Troubleshooting
    </a>
   </p>
   <div id="divd0e9743">
    <p class="toc-2-style">
     <a href="trb-forgotten-password-mve-topic.html#trb-forgotten-password-mve" title="User has forgotten the password">
      User has forgotten the password
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-admin-forgotten-password-mve-topic.html#trb-admin-forgotten-password-mve" title="Admin user has forgotten the password">
      Admin user has forgotten the password
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-page-loading-infinitely-topic.html#trb-page-loading-infinitely" title="Page does not load">
      Page does not load
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-discover-network-device-topic.html#trb-cannot-discover-network-device" title="Cannot discover a network printer">
      Cannot discover a network printer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-incorrect-device-information-topic.html#trb-incorrect-device-information" title="Incorrect printer information">
      Incorrect printer information
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-mve-does-not-recognize-secured-printer-topic.html#trb-mve-does-not-recognize-secured-printer" title="MVE does not recognize a printer as a secured printer">
      MVE does not recognize a printer as a secured printer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-config-enforcement-fails-topic.html#trb-config-enforcement-fails" title="Enforcement of configurations with multiple applications fails in the first attempt but succeeds in the subsequent attempts">
      Enforcement of configurations with multiple applications fails in the first attempt but succeeds in the subsequent attempts
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-enforcement-printer-cert-fails-topic.html#trb-enforcement-printer-cert-fails" title="Enforcement of configurations with printer certificate fails">
      Enforcement of configurations with printer certificate fails
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-openxpki-ca-group.html#d0e9962" title="OpenXPKI Certificate Authority">
      OpenXPKI Certificate Authority
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="appendix-chapter.html#appendix-chapter" title="Appendix">
     Appendix
    </a>
   </p>
   <div id="divd0e10132">
    <p class="toc-2-style">
     <a href="understanding-ports-and-protocols-topic.html#understanding-ports-and-protocols" title="Understanding ports and protocols">
      Understanding ports and protocols
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-automatic-approval-certificate-requests-microsoft-ca-topic.html#enabling-automatic-approval-certificate-requests-microsoft-ca" title="Enabling automatic approval of certificate requests in Microsoft CA">
      Enabling automatic approval of certificate requests in Microsoft CA
     </a>
    </p>
    <p class="toc-2-style">
     <a href="revoking-certificates-topic.html#revoking-certificates" title="Revoking certificates">
      Revoking certificates
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="leap_notices.html#leap_notices" title="Notices">
     Notices
    </a>
   </p>
   <div id="divd0e10508">
    <p class="toc-2-style">
     <a href="leap_notices.html#d0e10511" title="Edition notice">
      Edition notice
     </a>
    </p>
    <p class="toc-2-style">
     <a href="leap_notices.html#d0e10547" title="Trademarks">
      Trademarks
     </a>
    </p>
    <p class="toc-2-style">
     <a href="leap_notices.html#us-government-rights" title="GOVERNMENT END USERS">
      GOVERNMENT END USERS
     </a>
    </p>
    <p class="toc-2-style">
     <a href="leap_notices.html#jmdns-license" title="JmDNS License">
      JmDNS License
     </a>
    </p>
    <p class="toc-2-style">
     <a href="leap_notices.html#licensing-notices-program-folder" title="Licensing notices">
      Licensing notices
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="glossary.html#glossary" title="Glossary">
     Glossary
    </a>
   </p>
   <div id="divd0e10577">
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue